// extracted by mini-css-extract-plugin
export default {"news_container":"MarketNews_news_container__sSfPI","news_content":"MarketNews_news_content__mmX-f"};